module.exports = __webpack_public_path__ + "img/store.3bbb4032.svg";